module.exports = __webpack_public_path__ + "res/img/avatar_man_gray.c5d75416.png";